import { render, staticRenderFns } from "./most-sold-products.vue?vue&type=template&id=7a6f3bbe&scoped=true&"
import script from "./most-sold-products.vue?vue&type=script&lang=js&"
export * from "./most-sold-products.vue?vue&type=script&lang=js&"
import style0 from "./most-sold-products.vue?vue&type=style&index=0&id=7a6f3bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f3bbe",
  null
  
)

export default component.exports